import { useParams } from 'react-router-dom'
import { useResidentDetailWorkflow } from './useResidentDetailWorkflow'
import type { ResidentDetailPageType } from '../utils/residentDecoupling'

export function useResidentDetailPage(pageType: ResidentDetailPageType = 'resident-detail') {
  const { applicantId, userId } = useParams<{ applicantId: string; userId: string }>()
  return useResidentDetailWorkflow(applicantId, userId, pageType)
}

export type ResidentDetailPageContext = ReturnType<typeof useResidentDetailPage>
